import React, { ReactElement, ReactNode } from "react";
import { Tooltip, TooltipProps } from "@mui/material";
import { PremiumFeatureIcon } from "assets";

interface PremiumFeatureTooltipProps {
    icon?: ReactNode;
    title?: string;
    infoMessage?: string;
    children: ReactElement;
    placement?: TooltipProps["placement"];
}

export const PremiumFeatureTooltip = ({ icon, title = "Premium Feature", infoMessage = "Upgrade to unlock this feature.", children, placement = "top" }: PremiumFeatureTooltipProps) => {
    const tooltipContent = <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "180px" }}>
        <div style={{ display: "flex", alignItems: "flex-end", gap: "10px", fontWeight: 'bold', fontSize: "14px", lineHeight: 0.8 }}>
            {icon ?? <PremiumFeatureIcon />}
            <div>{title}</div>
        </div>
        <div style={{ fontSize: "12px" }}>{infoMessage}</div>
    </div>

    return <Tooltip title={tooltipContent} placement={placement} arrow>
        {children}
    </Tooltip >
};